import { isArray } from 'angular';

const $inject = ['$q', '$http', 'APP_CONFIG'];

const iataSearchService = function ($q, $http, APP_CONFIG) {
  var service = {};

  service.get = get;
  service.getGrouped = getGrouped;
  service.getMetroGrouped = getMetroGrouped;
  service.getIataFromLocation = getIataFromLocation;
  service.getIata = getIata;

  function get(params, grouped) {
    let deferred = $q.defer();
    let url = APP_CONFIG.api.iata;

    if (grouped) {
      url = APP_CONFIG.api.iataGrouped;
    }

    $http
      .get(url, { params: params })
      .then((response) => {
        if (!grouped) {
          let responseData = [];
          let groupKeys = [];

          _.forEach(response.data, (location) => {
            const groupedBy = groupedByKey(location);
            const displayLabel = `${location.Name} - ${location.City}, ${location.Country}`;
            const hasCode = !!location.Value;

            if (groupedBy && _.indexOf(groupKeys, groupedBy) === -1) {
              const selectedGroupLabel = groupedBySelectedLabel(location);
              const groupByLabel = groupedByLabel(location);
              const groupItem = _.extend({}, location, {
                isGroupHeader: true,
                groupedBy: groupedBy,
                displayLabel: groupByLabel,
                hasCode: !!location.GroupCode,
                Label: selectedGroupLabel,
                Value: location.GroupCode || location.Group,
              });

              responseData.push(groupItem);

              groupKeys.push(groupedBy);
            }

            location = _.extend(location, { displayLabel, groupedBy, hasCode });

            responseData.push(location);
          });

          deferred.resolve(responseData);
        } else {
          deferred.resolve(response.data);
        }
      })
      .catch((err) => {
        deferred.reject('there was an error');
      });

    return deferred.promise;
  }

  function getIata(code) {
    let deferred = $q.defer();
    let url = APP_CONFIG.api.iata;

    $http
      .get(url, {
        params: {
          code: code,
        },
      })
      .then((response) => {
        deferred.resolve(response.data);
        if (response.data) {
        }
      })
      .catch((err) => {
        deferred.reject('there was an error');
      });

    return deferred.promise;
  }

  function getGrouped(params) {
    let deferred = $q.defer();
    let url = APP_CONFIG.api.iata;

    $http
      .get(url, { params: params })
      .then((response) => {
        let responseData = [];

        _.forEach(response.data, (location) => {
          const groupedBy = groupedByKey(location);
          const displayLabel = `${location.Name} - ${location.City}${location.StateCode ? `, ${location.StateCode}` : ''}, ${
            location.Country
          }`;
          const hasCode = !!location.Value;

          location = _.extend(location, { displayLabel, groupedBy, hasCode });

          responseData.push(location);
        });

        deferred.resolve(responseData);
      })
      .catch((err) => {
        deferred.reject('there was an error');
      });

    return deferred.promise;
  }

  function getMetroGrouped(params, isPublic) {
    let deferred = $q.defer();
    let url = isPublic ? APP_CONFIG.api.iataSct : APP_CONFIG.api.iata;

    $http
      .get(url, { params: params, isPublic: isPublic })
      .then((response) => {
        let responseData = [];
        let groupKeys = [];

        _.forEach(response.data, (location) => {
          const exactMatch = params.term && params.term.length == 3 && params.term.toUpperCase() === location.Value;
          const groupedBy = groupedByMetroKey(location);
          const displayLabel = `${location.Name} - ${location.City}${location.StateCode ? `, ${location.StateCode}` : ''}, ${
            location.Country
          }`;
          const hasCode = !!location.Value;
          let groupItem = null;

          if (groupedBy && _.indexOf(groupKeys, groupedBy) === -1) {
            const selectedGroupLabel = groupedBySelectedLabel(location);
            const groupByLabel = groupedByLabel(location);
            groupItem = _.extend({}, location, {
              isGroupHeader: true,
              groupedBy: groupedBy,
              displayLabel: groupByLabel,
              hasCode: !!location.GroupCode,
              Label: selectedGroupLabel,
              Value: location.GroupCode || location.Group,
            });

            groupKeys.push(groupedBy);
          }
          //Reset value to airport now that we have set the group by
          location.AirportLocationType = 'Airport';

          location = _.extend(location, { displayLabel, groupedBy, hasCode });

          if (groupItem) {
            responseData.push(groupItem);
          }

          if (exactMatch && !location.groupedBy) {
            responseData.unshift(location);
          } else if (exactMatch) {
            responseData.push(location);
          }

          if (!exactMatch) {
            responseData.push(location);
          }
        });

        deferred.resolve(responseData);
      })
      .catch((err) => {
        deferred.reject('there was an error');
      });

    return deferred.promise;
  }

  function groupedByKey(location) {
    return location.Group ? `${location.Group} (All Airports)` : undefined;
  }

  function groupedByMetroKey(location) {
    return location.GroupCode || location.Group || undefined;
  }

  function groupedByLabel(location) {
    let label = undefined;

    if (location.Group) {
      label = `${location.Group} (All Airports) - ${location.City}${location.StateCode ? `, ${location.StateCode}` : ''}, ${
        location.Country
      }`;
    }

    return label;
  }

  function groupedBySelectedLabel(location) {
    let label = location.Group;

    if (location.GroupCode && location.AirportLocationType !== 'CustomHub') {
      label += ` (${location.GroupCode})`;
    }

    return label;
  }

  function getIataFromLocation(location) {
    return {
      Value: location.Code,
      City: location.City,
      Country: location.Country,
      CountryCode: location.CountryCode,
      Name: location.Location,
      displayLabel: `${location.Location} - ${location.City}, ${location.Country}`,
    };
  }

  return service;
};

iataSearchService.$inject = $inject;

export default iataSearchService;



// WEBPACK FOOTER //
// ./src/services/iataSearchService.js